import { createPortal } from 'react-dom';
import { useAppStore } from '@/store/appStore';
import { X } from 'lucide-react';
import { timeAgo } from '@/lib/utils';

const mockNotifications = [
  { id: 1, type: 'critical', title: 'Device offline', message: 'NYC-DC01 has been offline for 23 minutes', time: '2024-08-19T21:24:00Z' },
  { id: 2, type: 'warning', title: 'High CPU', message: 'CHI-DB01 CPU usage at 94%', time: '2024-08-19T21:10:00Z' },
  { id: 3, type: 'info', title: 'Job completed', message: 'Patch deployment completed on 12 devices', time: '2024-08-19T20:45:00Z' },
  { id: 4, type: 'critical', title: 'Antivirus inactive', message: 'LDN-WS02 antivirus protection is inactive', time: '2024-08-19T19:30:00Z' },
  { id: 5, type: 'warning', title: 'Low disk space', message: 'SAO-DC01 free disk below 10% on drive C:', time: '2024-08-19T18:15:00Z' },
];

export function NotificationCenter() {
  const open = useAppStore((s) => s.notificationOpen);
  const setOpen = useAppStore((s) => s.setNotificationOpen);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[90]" onClick={() => setOpen(false)}>
      <div className="absolute top-14 right-4 w-80 surface-elevated animate-slide-up overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="text-sm font-semibold">Notifications</h3>
          <button onClick={() => setOpen(false)} className="text-text-muted hover:text-text-primary">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {mockNotifications.map((n) => {
            const color = n.type === 'critical' ? 'var(--status-critical)' : n.type === 'warning' ? 'var(--status-warning)' : 'var(--status-info)';
            return (
              <div key={n.id} className="flex items-start gap-3 px-4 py-3 border-b border-border-subtle hover:bg-base-hover transition-colors cursor-pointer">
                <span className="h-2 w-2 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: color }} />
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-medium text-text-primary">{n.title}</div>
                  <div className="text-xs text-text-muted mt-0.5 truncate">{n.message}</div>
                  <div className="text-2xs text-text-disabled mt-1">{timeAgo(n.time)}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="px-4 py-2.5 border-t border-border">
          <button className="text-xs text-accent hover:text-accent-hover font-medium">Mark all as read</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
